export default __webpack_public_path__ + "static/media/STLBMOutcome07082025.3afb9306.pdf";